const partners = [
  {
    icon: "ri-bank-line",
    title: "Development Finance Institutions",
    desc: "Organizations focused on economic development, financial inclusion, and long-term investment in African markets and diaspora communities.",
    tag: "Finance",
  },
  {
    icon: "ri-government-line",
    title: "Public-Private Partnership Stakeholders",
    desc: "Entities bridging public sector goals with private sector capability to create scalable, sustainable impact across East Africa and the diaspora.",
    tag: "Public-Private",
  },
  {
    icon: "ri-home-office-line",
    title: "Local Family Offices",
    desc: "Nairobi and East Africa-based family offices seeking structured collaboration, co-investment alignment, and shared advisory frameworks.",
    tag: "Family Offices",
  },
  {
    icon: "ri-global-line",
    title: "Diaspora-Aligned Collaborators",
    desc: "Diaspora networks, associations, and community leaders committed to channeling diaspora energy and capital toward structured, long-term opportunity.",
    tag: "Diaspora",
  },
  {
    icon: "ri-graduation-cap-line",
    title: "Educational &amp; Workforce Development Organizations",
    desc: "Institutions and programs focused on financial literacy, professional development, and building investor-ready communities.",
    tag: "Education",
  },
  {
    icon: "ri-community-line",
    title: "Community Organizations",
    desc: "Grassroots and community-based organizations working to improve financial access, awareness, and long-term economic wellbeing.",
    tag: "Community",
  },
  {
    icon: "ri-briefcase-4-line",
    title: "Strategic Business &amp; Advisory Partners",
    desc: "Professional services firms, advisory practices, and strategic consultants aligned with Harambee&apos;s mission and client base.",
    tag: "Advisory",
  },
  {
    icon: "ri-seedling-line",
    title: "Mission-Aligned Ventures",
    desc: "Impact-driven businesses and ventures whose work intersects with financial education, diaspora empowerment, and African economic development.",
    tag: "Impact",
  },
];

export default function WhoWePartnerWith() {
  return (
    <section className="py-24 px-6 bg-[#F8F6F3]">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-5">
            <span className="w-8 h-px bg-[#C9A961]" />
            Who We Partner With
            <span className="w-8 h-px bg-[#C9A961]" />
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F] leading-tight mb-5">
            Partnerships Across Every Sector of Impact
          </h2>
          <p className="text-[#6B6B6B] text-base leading-relaxed">
            We collaborate with a diverse range of organizations united by a shared commitment to education, opportunity, and long-term wealth creation for the African Diaspora.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {partners.map((item) => (
            <div
              key={item.title}
              className="bg-white rounded-lg p-7 border border-[#E8E4DC] hover:border-[#C9A961]/40 transition-all duration-300 group"
            >
              <div className="flex items-start justify-between mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#1A4D3C]/10 group-hover:bg-[#1A4D3C]/20 transition-colors">
                  <i className={`${item.icon} text-[#1A4D3C] text-lg`} />
                </div>
                <span className="text-[10px] font-semibold uppercase tracking-wider text-[#C9A961] bg-[#C9A961]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <h3
                className="font-['Cormorant_Garamond'] text-lg font-bold text-[#2B2D2F] mb-2.5 leading-snug"
                dangerouslySetInnerHTML={{ __html: item.title }}
              />
              <p
                className="text-[#6B6B6B] text-xs leading-relaxed"
                dangerouslySetInnerHTML={{ __html: item.desc }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
